import { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../../utils/constant";
import { useCommonContext } from "../../../utils/context";
import { useTypeConfig } from "../../../utils/useTypeConfig";
import PermissionModal from "../PermissionModel";

const SubCustomerModal = ({
  show,
  handleClose,
  subCustomerData,
  selectedCustomer,
  fetchSubCustomers,
}) => {
  const { fetchCustomers } = useCommonContext();
  const [loading, setLoading] = useState(false);
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [allowedPermissions, setAllowedPermissions] = useState([]);
  const { labels, hiddenFields } = useTypeConfig();

  const [customerDetails, setCustomerDetails] = useState({
    customer_id: "",
    customer_name: "",
    companyName: "",
    mobileNo: "",
    emailId: "",

    modelNo: "",
    primaryAddress: "",
    landmarkPACI: "",
    country: "",
    state: "",
    city: "",
    zipcode: "",
    region: "",
  });

  const [errors, setErrors] = useState({});

  const resetFormFields = () => {
    setCustomerDetails({
      emailId: "",
      mobileNo: "",
      customer_name: "",
      companyName: "",
      customer_id: "",

      modelNo: "",
      primaryAddress: "",
      landmarkPACI: "",
      country: "",
      state: "",
      city: "",
      zipcode: "",
      region: "",
    });
    setErrors({});
    setAllowedPermissions([]);
  };

  useEffect(() => {
    if (subCustomerData) {
      setCustomerDetails({
        customer_name: subCustomerData.customer_name || "",
        companyName: subCustomerData.company_name || "",
        mobileNo: subCustomerData.phone_number || "",
        emailId: subCustomerData.email || "",

        modelNo: subCustomerData.model_no || "",
        primaryAddress: subCustomerData.primary_address || "",
        landmarkPACI: subCustomerData.landmark_paci || "",
        country: subCustomerData.country || "",
        city: subCustomerData.city || "",
        state: subCustomerData.state || "",
        zipcode: subCustomerData.zipcode || "",
        region: subCustomerData.region || "",
        customer_id: subCustomerData.customer_id || "",
      });
      setAllowedPermissions(subCustomerData.user_permissions || []);
    } else {
      resetFormFields();
    }
  }, [subCustomerData, show]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setCustomerDetails((prev) => ({
      ...prev,
      [id]: value,
    }));

    if (id === "mobileNo" || id === "zipcode") {
      const numericValue = value.replace(/\D/g, "").replace(/^0+/, "");

      setCustomerDetails({ ...customerDetails, [id]: numericValue });
    } else {
      setCustomerDetails({ ...customerDetails, [id]: value });
    }

    setErrors({ ...errors, [id]: "" });
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    // if (!String(customerDetails.customer_id || "").trim()) {
    //   newErrors.customer_id = "Customer selection is required.";
    //   valid = false;
    // }

    if (!customerDetails.emailId.trim()) {
      newErrors.emailId = "Email is required.";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(customerDetails.emailId)) {
      newErrors.emailId = "Email is invalid.";
      valid = false;
    }

    if (!customerDetails.mobileNo.trim()) {
      newErrors.mobileNo = "Mobile number is required.";
      valid = false;
    } else if (!/^\d{10}$/.test(customerDetails.mobileNo)) {
      newErrors.mobileNo = "Mobile number must be 10 digits.";
      valid = false;
    }

    if (!customerDetails.customer_name.trim()) {
      newErrors.customer_name = "Name is required.";
      valid = false;
    }

    if (!customerDetails.primaryAddress.trim()) {
      newErrors.primaryAddress = "Address is required.";
      valid = false;
    }

    if (!customerDetails.landmarkPACI.trim()) {
      newErrors.landmarkPACI = "Landmark is required.";
      valid = false;
    }

    if (!customerDetails.country.trim()) {
      newErrors.country = "Country is required.";
      valid = false;
    }

    if (!customerDetails.state.trim()) {
      newErrors.state = "State is required.";
      valid = false;
    }

    if (!customerDetails.city.trim()) {
      newErrors.city = "City is required.";
      valid = false;
    }

    if (!customerDetails.zipcode.trim()) {
      newErrors.zipcode = "Zipcode is required.";
      valid = false;
    } else if (!/^\d{6}$/.test(customerDetails.zipcode)) {
      newErrors.zipcode = "Zipcode must be a 6-digit number.";
      valid = false;
    }

    if (!customerDetails.region.trim()) {
      newErrors.region = "Region is required.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleFormSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    const payload = {
      email: customerDetails.emailId,
      phone_number: customerDetails.mobileNo,
      customer_name: customerDetails.customer_name,
      company_name: customerDetails.companyName,
      customer_id: selectedCustomer.id,

      model_no: customerDetails.modelNo,
      primary_address: customerDetails.primaryAddress,
      landmark_paci: customerDetails.landmarkPACI,
      country: customerDetails.country,
      state: customerDetails.state,
      city: customerDetails.city,
      zipcode: customerDetails.zipcode,
      region: customerDetails.region,
      role: "subcustomer",
    };

    if (
      JSON.stringify(allowedPermissions) !==
      JSON.stringify(customerDetails.user_permissions)
    ) {
      payload.user_permissions = allowedPermissions;
    }

    try {
      let response;

      if (subCustomerData) {
        response = await axios.put(
          `${BASE_URL}/users/tms_users/${subCustomerData.id}/`,
          payload,
          { headers: HEADERS },
        );
      } else {
        response = await axios.post(`${BASE_URL}/users/tms_users/`, payload, {
          headers: HEADERS,
        });
      }

      if (response.status === 201 || response.status === 200) {
        toast.success(
          `${labels.subCustomer} ${
            subCustomerData ? "updated" : "added"
          } successfully!`,
        );

        handleClose();

        await fetchSubCustomers();

        await fetchCustomers();
      } else {
        toast.error(
          `Failed to ${subCustomerData ? "update" : "add"} ${
            labels.subCustomer
          }. Please try again.`,
        );
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorData = error.response.data.error;

        if (typeof errorData === "object" && !Array.isArray(errorData)) {
          Object.entries(errorData).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((message) => {
                toast.error(`${message}`);
              });
            } else {
              toast.error(`${messages}`);
            }
          });
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        resetFormFields();
        handleClose();
      }}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {subCustomerData
            ? `Edit ${labels.subCustomer}`
            : `Add ${labels.subCustomer}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="mb-3">
            <Col>
              <Form.Group controlId="customer_id" className="mb-3">
                <div className="fw-bold text-dark">
                  {labels.customer} - {selectedCustomer?.customer_name}
                </div>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <Form.Group
                controlId="customer_name"
                className="form-floating mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder={labels.subCustomerName}
                  value={customerDetails.customer_name}
                  isInvalid={!!errors.customer_name}
                  onChange={handleInputChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.customer_name}
                </Form.Control.Feedback>
                <Form.Label>{labels.subCustomerName}*</Form.Label>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="mobileNo" className="form-floating ">
                <Form.Control
                  type="text"
                  placeholder="Mobile No."
                  value={customerDetails.mobileNo}
                  onChange={handleInputChange}
                  isInvalid={!!errors.mobileNo}
                  // disabled={!!subCustomerData}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.mobileNo}
                </Form.Control.Feedback>
                <Form.Label>Mobile No*</Form.Label>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <Form.Group controlId="emailId" className="form-floating mb-3">
                <Form.Control
                  type="email"
                  placeholder="Email Id"
                  value={customerDetails.emailId}
                  onChange={handleInputChange}
                  isInvalid={!!errors.emailId}
                  // disabled={!!subCustomerData}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.emailId}
                </Form.Control.Feedback>
                <Form.Label>Email Id*</Form.Label>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group
                controlId="companyName"
                className="form-floating mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder={labels.companyName}
                  value={customerDetails.companyName}
                  onChange={handleInputChange}
                  isInvalid={!!errors.companyName}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.companyName}
                </Form.Control.Feedback>
                <Form.Label>{labels.companyName} </Form.Label>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            {!hiddenFields.includes("model") && (
              <Col>
                <Form.Group controlId="modelNo" className="form-floating mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Model No"
                    value={customerDetails.modelNo}
                    onChange={handleInputChange}
                  />
                  <Form.Label>Model No</Form.Label>
                </Form.Group>
              </Col>
            )}
            <Col>
              <Form.Group controlId="region" className="form-floating mb-3">
                <Form.Select
                  value={customerDetails.region}
                  onChange={handleInputChange}
                  required
                  isInvalid={!!errors.region}
                >
                  <option value="" disabled>
                    Select Region
                  </option>
                  <option value="North">North</option>
                  <option value="West">West</option>
                  <option value="East">East</option>
                  <option value="South">South</option>
                </Form.Select>
                <Form.Label>Region*</Form.Label>

                <Form.Control.Feedback type="invalid">
                  {errors.region}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group
                controlId="primaryAddress"
                className="form-floating mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="Primary Address"
                  value={customerDetails.primaryAddress}
                  onChange={handleInputChange}
                  required
                  isInvalid={!!errors.primaryAddress}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.primaryAddress}
                </Form.Control.Feedback>
                <Form.Label>Address*</Form.Label>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group
                controlId="landmarkPACI"
                className="form-floating mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="Landmark / PACI"
                  value={customerDetails.landmarkPACI}
                  onChange={handleInputChange}
                  required
                  isInvalid={!!errors.landmarkPACI}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.landmarkPACI}
                </Form.Control.Feedback>
                <Form.Label>Landmark*</Form.Label>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="city" className="form-floating mb-3">
                <Form.Control
                  type="text"
                  placeholder="City"
                  value={customerDetails.city}
                  onChange={handleInputChange}
                  required
                  isInvalid={!!errors.city}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.city}
                </Form.Control.Feedback>
                <Form.Label>City*</Form.Label>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="state" className="form-floating mb-3">
                <Form.Control
                  type="text"
                  placeholder="State"
                  value={customerDetails.state}
                  onChange={handleInputChange}
                  required
                  isInvalid={!!errors.state}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.state}
                </Form.Control.Feedback>
                <Form.Label>State*</Form.Label>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="zipcode" className="form-floating mb-3">
                <Form.Control
                  type="text"
                  placeholder="Zip Code"
                  value={customerDetails.zipcode}
                  onChange={handleInputChange}
                  required
                  isInvalid={!!errors.zipcode}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.zipcode}
                </Form.Control.Feedback>
                <Form.Label>Zip Code*</Form.Label>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="country" className="form-floating mb-3">
                <Form.Control
                  type="text"
                  placeholder="Country"
                  value={customerDetails.country}
                  onChange={handleInputChange}
                  required
                  isInvalid={!!errors.country}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.country}
                </Form.Control.Feedback>
                <Form.Label>Country*</Form.Label>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group controlId="region" className="form-floating mb-3">
                <Form.Select
                  value={customerDetails.region}
                  onChange={handleInputChange}
                  required
                  isInvalid={!!errors.region}
                >
                  <option value="" disabled>
                    Select Region
                  </option>
                  <option value="North">North</option>
                  <option value="West">West</option>
                  <option value="East">East</option>
                  <option value="South">South</option>
                </Form.Select>
                <Form.Label>Region*</Form.Label>

                <Form.Control.Feedback type="invalid">
                  {errors.region}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          {/* <Row className="mb-3 mt-3">
            <Col xs="auto">
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() => setShowPermissionModal(true)}
              >
                {subCustomerData ? "Edit Permissions" : "Select Permissions"}
              </Button>
            </Col>
          </Row> */}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleFormSubmit} disabled={loading}>
          {loading ? (
            <Spinner animation="border" role="status" size="sm">
              <span className="visually-hidden"></span>
            </Spinner>
          ) : subCustomerData ? (
            "Update"
          ) : (
            "Add"
          )}
        </Button>
      </Modal.Footer>
      {showPermissionModal && (
        <PermissionModal
          show={showPermissionModal}
          handleClose={() => setShowPermissionModal(false)}
          setAllowedPermissions={setAllowedPermissions}
          userEditDetails={{ permissions: allowedPermissions }}
          agentData={subCustomerData} 
        />
      )}
    </Modal>
  );
};

export default SubCustomerModal;
